import React from 'react';
import Background from '../Icons/ajgbackgroundc.jpeg';
import AnimateOnScroll from '../components/AnimateOnScroll';
import Padding from './Padding';

class Revolution extends React.Component {
    constructor(props) {
      super(props)
      this.myRef = React.createRef()
      this.state = {scrollTop: 0}
    }

    render() {

        return (

      <>

      <Padding/>
      <div id="full-panel">

      <div className='row' style={{padding: '10vh'}}>  
        </div>

      <AnimateOnScroll direction="zoom" duration={800} distance={0}>

      <div id="holding" style={{backgroundImage:`url(${Background})`}}> 

        <div className='row'>
          <div className='column'>
            <div className='b-column'>
        
              <div id='strapline' className='row'>
              <h2>Revolutionising industries with cutting-edge software solutions</h2>
              </div>

              <div className='row' style={{height: '100px'}}>
              <h1>
                Software consultancy and development located in Cheshire, England.
                <br /> 
                <span style={{ fontSize: 'inherit', fontWeight: 'inherit' }}>
                  Specialising in Bespoke Software, AI, IoT, Industrial Automation and Vision.
                </span>
              </h1>
              </div>
            </div>
          </div>
          <div className='column'>
            <div className='g-column'>
            </div>
          </div>
        </div>
      </div>
      </AnimateOnScroll>
      </div>
      </>
      )
    }
  }

  export default Revolution;
